<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 class="pt-0">
            <v-card>
              <v-card-title class="py-0 px-1 grey lighten-4">
                <v-flex xs10 class="pa-0">
                  <span v-for="(chip, index) in reportChip" :key="index">
                    <v-chip class="mx-1" :style="$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'" small @click="loadDashboardBasedOnPeriod(chip)" :class="enableChip === chip ? 'info white--text' : ''">
                      {{chip}}
                    </v-chip>
                  </span>
                </v-flex>
                <v-flex xs2 class="text-right">
                  <v-chip class="grey px-2 white--text" @click="EnableTrend()" :class="enableTrend === true ? 'accent white--text' : ''">TREND</v-chip>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                  class="title"
                  v-model="lDashBoard.comm_id"
                  :items="commList"
                  item-text="comm_name"
                  item-value="comm_id"
                  label="Community"
                  hide-details
                  clearable
                  @input="loadDailyDashboardSummary"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 class="px-0" v-if="enableChip === 'Period'">
                  <v-layout row wrap class="ml-2">
                    <v-flex xs5 class="pl-0">
                      <v-dialog ref="dlgPeriodFrom"
                      persistent v-model="dlgPeriodFrom"
                      max-width="290px"
                      :return-value.sync="periodFrom"
                      >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                        slot="activator" label="From"
                        v-model="periodFrom" append-icon="mdi-calendar-today"
                        readonly clearable hide-details
                        v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="periodFrom" scrollable
                      first-day-of-week="1"
                      >
                      <v-spacer></v-spacer>
                      <v-btn text @click="dlgPeriodFrom = false">Cancel</v-btn>
                      <v-btn text color="accent" @click="$refs.dlgPeriodFrom.save(periodFrom)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs5 class="pr-0">
                  <v-dialog ref="dlgPeriodTo"
                  persistent v-model="dlgPeriodTo"
                  max-width="290px"
                  :return-value.sync="periodTo"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    label="To"
                    v-model="periodTo" append-icon="mdi-calendar-today"
                    readonly clearable hide-details
                    v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="periodTo" scrollable
                  first-day-of-week="1"
                  >
                  <v-spacer></v-spacer>
                  <v-btn text @click="dlgPeriodTo = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.dlgPeriodTo.save(periodTo)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs2 class="text-center">
              <v-btn small fab class="accent mt-1" @click.native="loadDashboardBasedOnPeriod('Period')">Go</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-layout row wrap>
          <v-flex xs12 class="text-right">
            <v-btn small class="mr-2 my-0 ml-0" @click="showUploadImage = true"><v-icon class="pr-2">mdi-camera-burst</v-icon>{{ 'Photos (' + lDailyUpdateAttach.fileUrls.length + ')'}}</v-btn>
            <router-link :to="{ path: '/DailyReport/' + lDashBoard.comm_id + '_' + handy.formatDBDate(fromDate) }" style="text-decoration: none; color: black;">
              <v-btn small class="ma-0 accent" :disabled="!aDay">GENERATE REPORT</v-btn>
            </router-link>
          </v-flex>
          <!-- Attendance Summary -->
          <v-flex xs12>
            <v-card>
              <v-card-title class="pl-2 py-0 pr-0 grey lighten-4">
                <div class="title primary--text">Attendance<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
                <v-spacer></v-spacer>
                <v-btn icon class="black--text" @click="showAttendanceSummary()"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </v-card-title>
              <v-card-text class="pt-3">
                <v-layout>
                  <v-flex xs12 sm6 mx-auto>
                    <div>
                      <v-layout row wrap class="text-center">
                        <v-flex xs12 class="pb-3">
                          <v-btn large fab color="blue white--text title" @click="showAttendanceSummary()">{{ this.lAtt.attAve + '%' }}</v-btn>
                        </v-flex>
                        <v-flex class="pa-0">
                          <v-chip color="rgba(227,108,9,0.8)" class="white--text subheading px-4 mx-0">{{ (this.lAtt.tot_present ? this.lAtt.tot_present : 0) + '/' + this.lAtt.tot_staff }}</v-chip>
                          <div>Present</div>
                        </v-flex>
                        <v-flex class="pa-0">
                          <v-chip color="rgba(149,55,52,0.8)" class="white--text subheading px-4 mx-0">{{ this.lAtt.tot_wo ? this.lAtt.tot_wo : 0 }}</v-chip>
                          <div>WO</div>
                        </v-flex>
                        <v-flex class="pa-0">
                          <v-chip color="rgba(118,146,60,0.8)" class="white--text subheading px-4 mx-0">{{ this.lAtt.tot_ot ? this.lAtt.tot_ot : 0 }}</v-chip>
                          <div>Sby/OT</div>
                        </v-flex>
                        <v-flex class="pa-0">
                          <v-chip color="rgba(95,73,122,0.8)" class="white--text subheading px-4 mx-0">{{ (this.lAtt.tot_absent || this.lAtt.tot_leave) ? (this.lAtt.tot_absent + this.lAtt.tot_leave) : 0 }}</v-chip>
                          <div>Leave/Ab</div>
                        </v-flex>
                        <v-flex class="pa-0">
                          <v-chip color="rgba(54,96,146,0.8)" class="white--text subheading px-4">{{ this.lAtt.tot_pend || 0 }}</v-chip>
                          <div>Pending</div>
                        </v-flex>
                        <v-flex xs12 v-if="enableTrend === true">
                          <v-layout row wrap>
                            <v-flex xs5>
                              <v-divider class="mt-2 primary"></v-divider>
                            </v-flex>
                            <v-flex xs2 class="caption primary--text">
                              TREND
                            </v-flex>
                            <v-flex xs5>
                              <v-divider class="mt-2 primary"></v-divider>
                            </v-flex>
                            <v-flex xs12>
                              <div id="div_attend">
                                <canvas id="chart_attend"></canvas>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-flex xs12>
                <v-layout>
                  <v-flex xs11 class="pa-0">
                    <div :class="aDay ? 'caption pl-1' : 'caption pl-1 pt-3'">
                      <span style="font-weight: bold;">Remark:</span> {{ lReport.remark_attendance ? lReport.remark_attendance : 'NA' }}
                    </div>
                  </v-flex>
                  <v-flex xs1 class="pa-0 text-center">
                    <v-btn class="accent--text" text v-if="!aDay" @click="loadMoreRemark('Att')">More</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card>
              <v-card-title class="pa-2 grey lighten-4">
                <div class="title primary--text">Water Management<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
              </v-card-title>
              <v-card-text class="pt-3">
                <v-layout row wrap>
                  <!-- Water Quality -->
                  <v-flex xs12>
                    <v-card>
                      <v-card-title class="title pr-0 py-0">
                        <span>Water Quality{{!aDay ? ' (Average)' : ''}}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="$vuetify.breakpoint.smAndUp ? loadTrendOverADayBasedOnPeriod('6 hrs', 'Quality') : loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Quality')" :disabled="!aDay">
                          <v-icon class="black--text">mdi-open-in-new</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text class="pa-0">
                        <v-layout row wrap>
                          <v-flex xs12 class="text-center">
                            <v-data-table
                            :headers="watQualHead"
                            :items="watList"
                            hide-default-footer
                            :mobile-breakpoint="0"
                            >
                            <template slot="item" slot-scope="props">
                              <tr @click="$vuetify.breakpoint.smAndUp ? loadTrendOverADayBasedOnPeriod('6 hrs', 'Quality', props.item.param_name) : loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Quality', props.item.param_name)">
                                <td>{{ props.item.param_name + props.item.param_value }}</td>
                                <td :class="'pa-2 ' + (watQualVal.val && (watQualVal.val < props.item.std_val_min || watQualVal.val > props.item.std_val_max) ? 'red white--text' : (watQualVal.val ? 'green lighten-3' : ''))" v-for="(watQualVal, i) in props.item.waterQualTypeValue" :key="i">
                                  {{ watQualVal.val ? watQualVal.val : '-' }}
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-flex>
                        <v-flex xs12 v-if="enableTrend === true" class="pa-3">
                          <v-layout row wrap>
                            <v-flex xs5>
                              <v-divider class="mt-2 primary"></v-divider>
                            </v-flex>
                            <v-flex xs2 class="caption primary--text">
                              TREND
                            </v-flex>
                            <v-flex xs5>
                              <v-divider class="mt-2 primary"></v-divider>
                            </v-flex>
                            <v-flex xs8 sm4 mx-auto class="pb-2 pt-0">
                              <v-select
                              v-model="waterQualType"
                              :items="waterQualParamList"
                              label="Parameter"
                              hide-details
                              @input="loadWaterQualChart()"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 class="pa-2">
                              <div id="div_watqualtrend">
                                <canvas id="chart_watqualtrend"></canvas>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Water Level -->
                <v-flex xs12 sm6>
                  <v-card>
                    <v-card-title class="title pb-0 pr-3 pt-2">
                      <v-flex xs12 class="pr-0">
                        <v-layout row wrap>
                          <v-flex xs10 class="pa-0">
                            <span>Water Level{{!aDay ? ' (Average)' : ''}}</span>
                          </v-flex>
                          <v-flex xs2 class="pa-0 text-right">
                            <v-btn icon @click="$vuetify.breakpoint.smAndUp ? loadTrendOverADayBasedOnPeriod('6 hrs', 'Level') : loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Level')" :disabled="!aDay">
                              <v-icon class="black--text">mdi-open-in-new</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card-title>
                    <v-card-text>
                      <v-layout row wrap class="text-center">
                        <v-flex xs12>
                          <div style="overflow-y: scroll; height: 198px; padding: 1rem 1rem 1rem 0px;">
                            <div id="div_watlvl">
                              <canvas id="chart_watlvl"></canvas>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex xs12 v-if="enableTrend === true">
                          <v-layout row wrap>
                            <v-flex xs5>
                              <v-divider class="mt-2 primary"></v-divider>
                            </v-flex>
                            <v-flex xs2 class="caption primary--text">
                              TREND
                            </v-flex>
                            <v-flex xs5>
                              <v-divider class="mt-2 primary"></v-divider>
                            </v-flex>
                            <v-flex xs12 class="pa-0">
                              <div id="div_watlvltrend" style="min-height: 218px;">
                                <canvas id="chart_watlvltrend"></canvas>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Water Consumption -->
                <v-flex xs12 sm6>
                  <v-card>
                    <v-card-title class="title pb-0 pr-3 pt-2">
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs10>
                            <v-layout row wrap>
                              <v-flex xs12 sm5 class="px-0 pb-0 pt-2 mt-1">
                                <span>Water {{!aDay ? 'Cons. (Total)' : 'Cons.'}}</span>
                              </v-flex>
                              <v-flex xs12 sm7 class="text-right">
                                <span v-for="(chip, index) in consumptionChip" :key="index" class="pr-2">
                                  <v-chip small @click="loadWaterConsumptionBasedonChip(chip)" :class="(choosenType === chip ? 'caption info white--text' : 'caption')">
                                    {{chip}}
                                  </v-chip>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs2 class="pa-0 text-right">
                            <v-btn icon @click="loadTrendOverADayBasedOnPeriod('6 hrs', 'Cons')" :disabled="!aDay">
                              <v-icon class="black--text">mdi-open-in-new</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card-title>
                    <v-card-text class="pt-0">
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs12 class="py-2 text-center">
                            <v-chip color="rgba(149,55,52,0.8)" class="white--text title">{{ consumedVal > 0 ? (consumedVal.toFixed(2) + ' KL') : 'NA' }}</v-chip>
                          </v-flex>
                          <!-- <v-flex xs6 class="pa-0 text-center">
                          <v-chip color="rgba(95,73,122,0.8)" class="white--text caption px-3 py-1">{{ receivedVal > 0 ? receivedVal.toFixed(2) : 'NA' }}</v-chip>
                          <br/>
                          <span class="caption">TOT RECEIVED (KL)</span>
                        </v-flex> -->
                      </v-layout>
                    </v-flex>
                    <v-layout row wrap class="text-center">
                      <v-flex xs12 sm8 class="pa-0">
                        <div style="overflow-y: scroll; height: 140px; padding: 1rem 1rem 1rem 0px;">
                          <div id="div_watcons">
                            <canvas id="chart_watcons"></canvas>
                          </div>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-flex xs12 v-if="!$vuetify.breakpoint.smAndUp">
                          <v-layout row wrap class="pt-2">
                            <v-flex class="mt-2">
                              <v-divider></v-divider>
                            </v-flex>
                            <v-flex xs6>
                              <div>
                                Water Sources (KL)
                              </div>
                            </v-flex>
                            <v-flex class="mt-2">
                              <v-divider></v-divider>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 v-else>
                          <b>SOURCES (KL)</b>
                        </v-flex>
                        <v-layout row wrap>
                          <v-flex xs12 v-for="(wat, i) in domWatList" :key="i" class="py-2 pl-2">
                            <v-layout row wrap>
                              <v-flex xs9 class="text-left black--text">
                                <div style="font-size: 12px;">{{wat.water_type}}</div>
                              </v-flex>
                              <v-flex xs3 class="text-left black--text">
                                <div style="font-size: 12px;">{{wat.water_receipt ? wat.water_receipt : 0}}</div>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 v-if="enableTrend === true">
                        <v-layout row wrap>
                          <v-flex xs5>
                            <v-divider class="mt-2 primary"></v-divider>
                          </v-flex>
                          <v-flex xs2 class="caption primary--text">
                            TREND
                          </v-flex>
                          <v-flex xs5>
                            <v-divider class="mt-2 primary"></v-divider>
                          </v-flex>
                          <v-flex xs8 sm6 mx-auto class="pb-3 pt-0">
                            <v-select
                            v-model="waterConsType"
                            :items="waterConsTypeList"
                            label="Storage"
                            hide-details
                            @input="loadWaterConsChart()"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12>
                            <div id="div_watconstrend">
                              <canvas id="chart_watconstrend"></canvas>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-flex xs12>
            <v-layout>
              <v-flex xs11 class="pa-0">
                <div :class="aDay ? 'caption pl-1' : 'caption pl-1 pt-3'">
                  <span style="font-weight: bold;">Remark:</span> {{ lReport.remark_water ? lReport.remark_water : 'NA' }}
                </div>
              </v-flex>
              <v-flex xs1 class="pa-0 text-center">
                <v-btn class="accent--text" text v-if="!aDay" @click="loadMoreRemark('Water')">More</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="pa-2 grey lighten-4">
            <div class="title primary--text">Power Management<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
          </v-card-title>
          <v-card-text class="pt-3">
            <v-layout row wrap>
              <!-- Power Consumption -->
              <v-flex xs12 sm6>
                <v-card>
                  <v-card-title class="title">
                    <v-flex xs10>
                      Power Consumption{{!aDay ? ' (Total)' : ''}}
                    </v-flex>
                    <v-flex xs2 class="pa-0 text-right">
                      <v-btn class="ma-0" icon @click="loadTrendOverADayBasedOnPeriod('', 'Power')">
                        <v-icon class="black--text">mdi-chart-pie</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap class="text-center">
                      <v-flex xs12 :style="$vuetify.breakpoint.smAndUp ? 'min-height: 158px;' : ''">
                        <v-layout row wrap class="text-center">
                          <v-flex xs6 @click="loadTrendOverADayBasedOnPeriod('', 'Power')" style="cursor: pointer;">
                            <div>
                              <v-chip @click="loadTrendOverADayBasedOnPeriod('', 'Power')" style="cursor: pointer;" color="rgba(95,73,122,0.8)" class="white--text title px-3">{{ powCons ? powCons + ' units' : 'NA' }}</v-chip>
                            </div>
                            <div>Electricity Board</div>
                          </v-flex>
                          <v-flex xs6 @click="loadTrendOverADayBasedOnPeriod('', 'Power')" style="cursor: pointer;">
                            <div>
                              <v-chip @click="loadTrendOverADayBasedOnPeriod('', 'Power')" style="cursor: pointer;" color="rgba(149,55,52,0.8)" class="white--text title px-3">{{ genCons ? genCons + ' units' : 'NA' }}</v-chip>
                            </div>
                            <div>Genset</div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 v-if="enableTrend === true">
                        <v-layout row wrap>
                          <v-flex xs5>
                            <v-divider class="mt-2 primary"></v-divider>
                          </v-flex>
                          <v-flex xs2 class="caption primary--text">
                            TREND
                          </v-flex>
                          <v-flex xs5>
                            <v-divider class="mt-2 primary"></v-divider>
                          </v-flex>
                          <v-flex xs12>
                            <div id="div_powconstrend">
                              <canvas id="chart_powconstrend"></canvas>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <!-- Diesel Consumption & Level -->
              <v-flex xs12 sm6>
                <v-card>
                  <v-card-title class="title">
                    <v-flex xs10>
                      Diesel Consumption &amp; Level
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap class="text-center">
                      <v-flex xs6 sm2 class="pl-0">
                        <div>
                          <v-chip color="rgba(95,73,122,0.8)" class="white--text subheading pa-3">{{ diCons ? diCons + ' L' : '0 L' }}</v-chip>
                        </div>
                        <div class="pl-1">Purchased{{!aDay ? ' (Total)' : ''}}</div>
                      </v-flex>
                      <v-flex xs6 sm2 class="pl-0">
                        <div>
                          <v-chip color="rgba(149,55,52,0.8)" class="white--text subheading pa-3">{{ diStock ? diStock + ' L' : '0 L' }}</v-chip>
                        </div>
                        <div class="pl-2">Stock{{!aDay ? ' (Average)' : ''}}</div>
                      </v-flex>
                      <v-flex xs12 sm8>
                        <div id="div_dicons">
                          <canvas id="chart_dicons"></canvas>
                        </div>
                      </v-flex>
                      <v-flex xs12 v-if="enableTrend === true">
                        <v-layout row wrap>
                          <v-flex xs5>
                            <v-divider class="mt-2 primary"></v-divider>
                          </v-flex>
                          <v-flex xs2 class="caption primary--text">
                            TREND
                          </v-flex>
                          <v-flex xs5>
                            <v-divider class="mt-2 primary"></v-divider>
                          </v-flex>
                          <v-flex xs12>
                            <div id="div_diconstrend">
                              <canvas id="chart_diconstrend"></canvas>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-flex xs12>
            <v-layout>
              <v-flex xs11 class="pa-0">
                <div :class="aDay ? 'caption pl-1' : 'caption pl-1 pt-3'">
                  <span style="font-weight: bold;">Remark:</span> {{ lReport.remark_power ? lReport.remark_power : 'NA' }}
                </div>
              </v-flex>
              <v-flex xs1 class="pa-0 text-center">
                <v-btn class="accent--text" text v-if="!aDay" @click="loadMoreRemark('Power')">More</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>
      <!-- Waste Management -->
      <v-flex xs12>
        <v-card>
          <v-card-title class="pa-2 grey lighten-4">
            <div class="title primary--text">Waste Management{{!aDay ? ' (Total)' : ''}}<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
          </v-card-title>
          <v-card-text class="pt-3">
            <v-layout row wrap class="text-center">
              <v-flex xs12>
                <div id="div_waste">
                  <canvas id="chart_waste"></canvas>
                </div>
              </v-flex>
              <v-flex xs12 v-if="enableTrend === true">
                <v-layout row wrap>
                  <v-flex xs5>
                    <v-divider class="mt-2 primary"></v-divider>
                  </v-flex>
                  <v-flex xs2 class="caption primary--text">
                    TREND
                  </v-flex>
                  <v-flex xs5>
                    <v-divider class="mt-2 primary"></v-divider>
                  </v-flex>
                  <v-flex xs12>
                    <div id="div_wastetrend">
                      <canvas id="chart_wastetrend"></canvas>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <!-- Hygiene Management / Sanity Checks -->
      <v-flex xs12>
        <v-card>
          <v-card-title class="px-2 py-0 grey lighten-4">
            <div class="title grey--text">Hygiene Management / Sanity Checks<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
          </v-card-title>
          <v-card-text class="pt-3">
            <v-layout row wrap class="text-left">
              <v-flex v-if="!aDay" class="pa-0">
                <v-btn text class="accent--text" @click="loadSanityChecksMore()">Click here to see the list for given period</v-btn>
              </v-flex>
              <v-flex xs12 v-else>
                <v-flex xs12 v-for="(cat, n) in hygCats" :key="n" :class="n > 0 ? 'pa-0 mt-1' : 'pa-0'" style="border: 1px solid black;">
                  <div class="text-left pa-2 primary white--text">{{cat.check_cat}}</div>
                  <v-data-table
                  hide-default-header
                  :items="hygList.filter(rec => rec.check_cat === cat.check_cat)"
                  hide-default-footer
                  disable-sort
                  >
                  <template slot="item" slot-scope="props">
                    <tr>
                      <td style="width:400px;" class="pr-0">{{ props.item.check_desc }}</td>
                      <td style="width: 50px;">
                        <v-checkbox v-model="props.item.check_value" class="pa-0" hide-details readonly></v-checkbox>
                      </td>
                      <td>{{ props.item.remark }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <!-- Safety & Security -->
    <v-flex xs12>
      <v-card>
        <v-card-title class="pa-2 grey lighten-4">
          <div class="title grey--text">Incidents<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
        </v-card-title>
        <v-card-text class="pt-3">
          <v-layout row wrap class="text-left">
            <v-flex v-if="!aDay" class="pa-0">
              <v-btn text class="accent--text" @click="loadIncidentMore()">Click here to see the list for given period</v-btn>
            </v-flex>
            <v-flex xs12 v-else>
              <v-flex xs12 v-for="(incident, n) in incidentTypes" :key="n"  style="border: 1px solid black;" :class="n > 0 ? 'pa-0 mt-1' : 'pa-0'">
                <div class="text-left pa-2 primary white--text">{{incident}}</div>
                <v-flex xs12 class="pa-0">
                  <v-data-table
                  hide-default-header
                  :items="incidentList.filter(rec => rec.incident_type === incident)"
                  hide-default-footer
                  disable-sort>
                  <template slot="item" slot-scope="props">
                    <tr>
                      <td style="width:315px;">{{ props.item.incident_class }}</td>
                      <td>{{ props.item.incident_on ? (handy.formatDate(props.item.incident_on) + ' ' + handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + handy.formatDate(props.item.incident_end) + ' ' + handy.getTime12Hrs(props.item.incident_end) : '') + ' - ' + props.item.incident_desc) : '' }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
  <!-- Custom Metrics -->
  <v-flex xs12 v-if="metricCat.length > 0">
    <v-card>
      <v-card-title class="pa-2 grey lighten-4">
        <div class="title primary--text">Custom Metrics<br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{chosenPeriod}}</span></div>
      </v-card-title>
      <v-card-text class="pa-3">
        <v-layout row wrap>
          <v-flex xs12 sm6 v-for="(cat, i) in metricCat" :key="i">
            <v-card>
              <v-card-title class="title">
                <v-flex xs12 class="text-center">
                  {{ cat }}
                </v-flex>
              </v-card-title>
              <v-card-text>
                <v-layout row wrap class="text-center">
                  <v-flex xs12>
                    <div :id="'div_other_' + cat.split(' ').join('_')">
                      <canvas :id="'chart_other_' + cat.split(' ').join('_')"></canvas>
                    </div>
                  </v-flex>
                  <v-flex xs12 v-if="enableTrend === true">
                    <v-layout row wrap>
                      <v-flex xs5>
                        <v-divider class="mt-2 primary"></v-divider>
                      </v-flex>
                      <v-flex xs2 class="caption primary--text">
                        TREND
                      </v-flex>
                      <v-flex xs5>
                        <v-divider class="mt-2 primary"></v-divider>
                      </v-flex>
                      <v-flex xs12>
                        <div :id="'div_other_trend_' + cat.split(' ').join('_')">
                          <canvas :id="'chart_other_trend_' + cat.split(' ').join('_')"></canvas>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</v-card-text>
</v-card>
</v-flex>
</v-layout>

<!-- Show Uploaded Images -->
<v-dialog v-model="showUploadImage" scrollable max-width="900px">
  <v-container grid-list-md class="pa-0">
    <v-card>
      <v-card-title class="py-2 title grey lighten-4">
        <div>Photos <span class="caption">{{chosenPeriod }}</span></div>
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="showUploadImage = false"><v-icon>mdi-close</v-icon></v-btn>
        <v-flex xs12 class="py-2">
          <span class="mr-2" v-for="(chip, index) in photoCatChips" :key="index">
            <v-chip :style="$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'" :color="lDailyUpdateAttach.cat === chip.attach_cat_id ? 'info white--text' : ''" @click="loadCategoryImage(chip.attach_cat_id)">
              {{chip.attach_cat_name + (lDailyUpdateAttach.fileUrls ? (lDailyUpdateAttach.fileUrls && lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === chip.attach_cat_id).length ? (' (' + lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === chip.attach_cat_id).length + ')') : '') : '') }}</v-chip>
            </span>
            <v-chip :color="lDailyUpdateAttach.cat === 'All' ? 'info white--text' : ''" @click="loadCategoryImage('All')">All ({{lDailyUpdateAttach.fileUrls && lDailyUpdateAttach.fileUrls.length}})</v-chip>
          </v-flex>
        </v-card-title>
        <v-card-text class="pt-1">
          <v-container class="pa-0" fluid v-if="lDailyUpdateAttach.files && lDailyUpdateAttach.files.length > 0">
            <v-row>
              <v-col
              v-for="(file, index) in lDailyUpdateAttach.files" :key="index"
              class="d-flex child-flex pa-1"
              cols="4"
              >
              <v-card flat tile class="d-flex">
                <v-img
                :src="handy.loadImg(file.file_url, true)"
                aspect-ratio="1"
                class="grey lighten-2"
                >
                <div class="white--text text-center caption" style="background-color:rgba(125, 125, 125, 0.5);">{{handy.formatDateTime(file.attach_timestamp)}}<br />by {{file.user_name}}</div>
                <div style="position:absolute; bottom:0px; width:100%; background-color:rgba(0, 0, 255, 0.5);" class="text-center white--text caption" v-if="file.notes">
                  {{ file.notes }}
                </div>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <span class="pa-2" v-else>No photos are available.</span>
    </v-card-text>
  </v-card>
</v-container>
</v-dialog>

<!-- Attendance summary -->
<v-dialog v-model="showSummary" persistent scrollable max-width="750px">
  <v-card>
    <v-card-title class="title grey lighten-4">
      <div>Attendance Summary</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showSummary = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp ? repHeadSm : repHead"
      :items="attReport"
      disable-pagination
      hide-default-footer>
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.staff_role }}</td>
          <td class="pa-0">{{ props.item.tot_present }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_wo }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_holiday }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_ot }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_leave }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_absent }}</td>
          <td class="red--text pa-0">{{ props.item.tot_pend }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- Water Quality summary -->
<v-dialog v-model="trendOverADay" persistent scrollable max-width="960px">
  <v-card>
    <v-card-title class="pa-2 pl-3 grey lighten-4">
      <div class="title grey--text">
        Trend over a day
        <br v-if="!$vuetify.breakpoint.smAndUp" />
        <span class="subheading">{{chosenPeriod}}</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="trendOverADay = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-flex xs12 class="text-center">
        <span v-for="(chip, index) in trendChip" :key="index" class="pl-2">
          <v-chip :style="$vuetify.breakpoint.smAndUp ? '' : 'width:22%;'" small @click="loadTrendOverADayBasedOnPeriod(chip, 'Quality')" :class="enableTrendChip === chip ? 'info white--text' : ''">
            {{chip}}
          </v-chip>
        </span>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs8 sm4 mx-auto class="py-2">
            <v-select
            v-model="waterQualiltyType"
            :items="waterQualParamList"
            label="Parameter"
            hide-details
            @change="showWaterQualityOverADay()"
            ></v-select>
          </v-flex>
          <v-flex xs12 class="pa-2">
            <div id="div_watqualoveradaytrend">
              <canvas id="chart_watqualoveradaytrend"></canvas>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-text>
  </v-card>
</v-dialog>

<!-- Water Level summary -->
<v-dialog v-model="lvlTrendOverADay" scrollable persistent max-width="960px">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-2 pr-2 grey lighten-4">
        <div class="title grey--text">
          Trend over a day
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="lvlTrendOverADay = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-layout wrap>
          <v-flex xs12 sm8>
            <v-select
            :class="$vuetify.breakpoint.smAndUp ? 'pt-0' : 'pt-0 pb-2'"
            v-model="selectedStorageNmWithWaterLvl"
            :items="storageNmListWithWaterLvl"
            item-value="storage_id"
            item-text="storage_nm"
            hide-details
            clearable
            @change="showWaterLevelOverADay()"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm4 :class="$vuetify.breakpoint.smAndUp ? 'text-right pt-2' : 'text-center'">
            <span v-for="(chip, index) in trendChip" :key="index" class="pl-2">
              <v-chip small @click="loadTrendOverADayBasedOnPeriod(chip, 'Level')" :class="enableTrendChip === chip ? 'info white--text' : ''">
                {{chip}}
              </v-chip>
            </span>
          </v-flex>
          <v-flex xs12 class="text-right pt-2" v-if="watTankBattery">
            <span>
              <v-icon v-if="watTankBattery > 20" style="transform: rotate(-90deg);" color="#00d455">mdi-battery</v-icon>
              <v-icon v-else style="transform: rotate(-90deg);" color="error">mdi-battery-alert</v-icon>
            </span>
            <span class="caption">{{watTankBattery + '%'}}</span>
          </v-flex>
          <v-flex xs12 class="pt-2">
            <div id="div_watlvloveradaytrend">
              <canvas id="chart_watlvloveradaytrend"></canvas>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</v-dialog>

<!-- Water Cons summary -->
<v-dialog v-model="consTrendOverADay" scrollable persistent max-width="960px">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-0 pr-0 grey lighten-4">
        <div class="title grey--text">
          Trend over a day
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="consTrendOverADay = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-flex xs12>
          <v-layout wrap>
            <v-flex xs12 sm8>
              <v-select
              :class="$vuetify.breakpoint.smAndUp ? 'pt-0' : 'pt-0 pb-2'"
              v-model="selectedStorageNmWithWaterCons"
              :items="storageNmListWithWaterCons"
              item-value="storage_id"
              item-text="storage_nm"
              hide-details
              clearable
              @change="showWaterConsOverADay()"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm4 :class="$vuetify.breakpoint.smAndUp ? 'text-right pt-2' : 'text-center'">
              <span v-for="(chip, index) in waterConsTrendChip" :key="index" class="pl-2">
                <v-chip small @click="loadTrendOverADayBasedOnPeriod(chip, 'Cons')" :class="enableTrendChip === chip ? 'info white--text' : ''">
                  {{chip}}
                </v-chip>
              </span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="pt-2">
          <div id="div_watConsoveradaytrend">
            <canvas id="chart_watConsoveradaytrend"></canvas>
          </div>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-flex>
</v-dialog>

<!-- Power Cons summary -->
<v-dialog v-model="showPowerConstrendOverADay" scrollable persistent max-width="960px">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-2 pr-2 grey lighten-4">
        <div class="title grey--text">
          Power Cons. Breakup
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="showPowerConstrendOverADay = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-flex xs12>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <div id="div_powconstrendoveraday" class="text-center">
                <canvas id="chart_powconstrendoveraday"></canvas>
              </div>
            </v-flex>
            <v-flex xs12 sm6>
              <div id="div_powgensettrendoveraday" class="text-center">
                <canvas id="chart_powgensettrendoveraday"></canvas>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-flex>
</v-dialog>

<!-- Sanity checks -->
<v-dialog v-model="showSanityChecks" scroll max-width="750">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-0 pr-0 grey lighten-4">
        <div class="title grey--text">
          Hygiene Management / Sanity Checks
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon class="pr-2" @click.stop="showSanityChecks = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pt-3">
        <v-flex xs12 v-for="(item, n) in lSan" :key="n" :class="n > 0 ? 'mt-2' : ''">
          <div class="pa-2 primary white--text">{{item}}</div>
          <v-data-table
          :headers="sanHeads"
          :items="sanList.filter(rec => handy.formatDate(rec.c_date) === item)"
          hide-default-footer
          disable-sort
          class="elevation-1"
          >
          <template slot="item" slot-scope="props">
            <tr>
              <td>{{ props.item.check_cat }}</td>
              <td>{{ props.item.check_desc }}</td>
              <td style="width: 340px;">{{ props.item.remark ? props.item.remark : '-' }}</td>
              <td class="text-right" style="width: 50px;">
                <v-checkbox v-model="props.item.check_value" class="pa-0" hide-details readonly></v-checkbox>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</v-flex>
</v-dialog>

<!-- Incident -->
<v-dialog v-model="showIncident" scroll max-width="750">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-0 pr-0 grey lighten-4">
        <div class="title grey--text">
          Incidents
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="showIncident = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pt-3">
        <v-flex xs12 v-for="(item, n) in lInc" :key="n" :class="n > 0 ? 'mt-2' : ''">
          <div class="pa-2 primary white--text">{{item}}</div>
          <v-data-table
          :headers="incHeads"
          :items="lIncident.filter(rec => handy.formatDate(rec.created_on) === item)"
          hide-default-footer
          disable-sort
          class="elevation-1"
          >
          <template slot="item" slot-scope="props">
            <tr>
              <td>{{ props.item.incident_type }}</td>
              <td>{{ props.item.incident_class }}</td>
              <td>{{ props.item.incident_desc }}</td>
              <td>{{ props.item.incident_on ? (handy.formatDate(props.item.incident_on) + ' ' + handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + handy.formatDate(props.item.incident_end) + ' ' + handy.getTime12Hrs(props.item.incident_end) : '')) : '' }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</v-flex>
</v-dialog>

<!-- More Attendance Remark -->
<v-dialog v-model="showRemark" scroll max-width="750">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-0 pr-0 grey lighten-4">
        <div class="title grey--text">
          <span>{{ lReport.remark === 'Att' ? 'Attendance Remarks' : lReport.remark === 'Power' ? 'Power Remarks' : lReport.remark === 'Water' ? 'Water Remarks' : '' }}</span>
          <br v-if="!$vuetify.breakpoint.smAndUp" />
          <span class="subheading">{{chosenPeriod}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="showRemark = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pt-3">
        <v-flex xs12>
          <v-data-table
          :headers="AttHeads"
          :items="lReport.remark === 'Att' ? lReport.AttRemark : lReport.remark === 'Power' ? lReport.PowerRemark : lReport.remark === 'Water' ? lReport.WaterRemark : ''"
          hide-default-footer
          disable-sort
          class="elevation-1"
          >
          <template slot="item" slot-scope="props">
            <tr>
              <td style="width: 150px;">{{ handy.formatDate(props.item.c_date) }}</td>
              <td v-if="lReport.remark === 'Att'">{{ props.item.remark_attendance ? props.item.remark_attendance : '-' }}</td>
              <td v-if="lReport.remark === 'Power'">{{ props.item.remark_power ? props.item.remark_power : '-' }}</td>
              <td v-if="lReport.remark === 'Water'">{{ props.item.remark_water ? props.item.remark_water : '-' }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</v-flex>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="3000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<style>
.ccolor1 {
  background-color:rgba(227,108,9,0.8);
}
.ccolor2 {
  background-color:rgba(49,133,155,0.8);
}
.ccolor3 {
  background-color:rgba(95,73,122,0.8);
}
.ccolor4 {
  background-color:rgba(118,146,60,0.8);
}
.ccolor5 {
  background-color:rgba(149,55,52,0.8);
}
.ccolor6 {
  background-color:rgba(54,96,146,0.8);
}
.ccolor7 {
  background-color:rgba(23,54,93,0.8);
}
.ccolor8 {
  background-color:rgba(73,68,41,0.8);
}
</style>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
var Chart = require('chart.js')
import 'chartjs-plugin-datalabels'

var COLORS = ['227,108,9', '49,133,155', '95,73,122', '118,146,60', '149,55,52', '54,96,146', '23,54,93', '73,68,41']

export default {
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      reportChip: ['Last Month', 'Last Week', 'Yesterday', 'Today', 'This Week', 'This Month', 'Period'],
      fromDate: null,
      toDate: null,
      trendFrom: null,
      trendTo: null,
      enableChip: '',
      handy: handy,
      config: config,
      lAtt: {
        tot_present: 0,
        tot_wo: 0,
        tot_holiday: 0,
        tot_ot: 0,
        tot_leave: 0,
        tot_absent: 0,
        tot_pend: 0,
        tot_staff: 0,
        attAve: 0
      },
      dlgPeriodFrom: false,
      dlgPeriodTo: false,
      periodFrom: '',
      periodTo: '',
      aDay: false,
      tmpChart: [],
      tmpChart2: [],
      enableTrend: false,
      waterConsType: '',
      consumptionChip: ['Domestic', 'Recycled/Treated'],
      choosenType: 'Domestic',
      domWatList: [],
      waterConsTypeList: [],
      waterQualParamList: [],
      waterQualType: '',
      waterQualiltyType: '',
      watQualHead: [], // constructed dynamically
      watList: [],
      tankerVal: 0,
      receivedVal: 0,
      consumedVal: 0,
      powCons: '',
      genCons: '',
      diCons: '',
      diStock: '',
      metricCat: [],
      lDailyUpdateAttach: {
        fileUrls: [],
        files: []
      },
      showUploadImage: false,
      photoCatChips: [],
      showSummary: false,
      repHeadSm: [
        { text: 'Role [Headcount]', value: 'staff_role' },
        { text: 'Present', value: 'tot_present', class: 'pa-0' },
        { text: 'Weekoff', value: 'tot_wo' },
        { text: 'Holiday', value: 'tot_holiday' },
        { text: 'Standby/OT', value: 'tot_ot' },
        { text: 'Leave', value: 'tot_leave' },
        { text: 'Absent', value: 'tot_absent' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }
      ],
      repHead: [
        { text: 'Role', value: 'staff_role' },
        { text: 'Present', value: 'tot_present', class: 'pa-0' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }
      ],
      attReport: [],
      lDashBoard: {},
      commList: [],
      trendOverADay: false,
      waterTypeLebel: [],
      trendChip: ['Last 1 hr', '6 hrs', '12 hrs', 'A day'],
      waterConsTrendChip: ['6 hrs', '12 hrs', 'A day'],
      enableTrendChip: '',
      fromTime: null,
      toTime: null,
      // water lvl summary
      storageNmListWithWaterLvl: [],
      selectedStorageNmWithWaterLvl: [],
      lvlTrendOverADay: false,
      watTankBattery: null,
      // water cons summary
      storageNmListWithWaterCons: [],
      selectedStorageNmWithWaterCons: [],
      consTrendOverADay: false,
      // power cons trend
      showPowerConstrendOverADay: false,
      // deisel pie chart
      showDieselPieChart: false,
      // Hygiene
      hygList: [],
      hygCats: {},
      sanHeads: [
        { text: 'Category', value: 'check_cat' },
        { text: 'Description', value: 'check_desc' },
        { text: 'Remark', value: 'remark' },
        { text: '', value: 'check_value' }
      ],
      sanList: [],
      showSanityChecks: false,
      lSan: {},
      // incident
      incidentList: [],
      incidentTypes: {},
      lIncident: [],
      lInc: {},
      incHeads: [
        { text: 'Type', value: 'incident_type' },
        { text: 'Class', value: 'incident_class' },
        { text: 'Description', value: 'incident_desc' },
        { text: 'Incident Date', value: 'incident_on' }
      ],
      showIncident: false,
      // remark
      lReport: {},
      showRemark: false,
      AttHeads: [
        { text: 'Date', value: 'c_date', width: '150px' },
        { text: 'Remark', value: 'remark_attendance' }
      ],
      // common
      nodata: false
    }
  },
  created () {
    this.loadCommunity()
  },
  mounted () {
    var curDate = new Date()
    this.periodFrom = this.periodTo = handy.formatDBDate(curDate)
  },
  computed: {
    chosenPeriod: function () {
      return ' [' + ((this.enableChip === 'Today' || this.enableChip === 'Yesterday') ? handy.formatDate(this.fromDate) : handy.formatDate(this.fromDate) + ' to ' + handy.formatDate(this.toDate)) + ']'
    }
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadDailyDashboardSummary () {
      this.loadAttChart()
      this.loadFacDailyUpdateAttachment()
      this.loadWaterConsType()
      this.loadWaterLevelChart()
      this.loadWaterConsChart()
      this.loadWaterQualChart()
      this.loadWaterSources()
      this.loadPowerConsChart()
      this.loadDieselConsChart()
      this.loadWasteChart()
      this.loadCustomMetricCat()
      this.loadOtherCustomMetricChart()
      this.loadPhotoCat()
      this.loadRemark()
      this.loadHygieneCat()
      this.loadIncidentClass()
    },
    loadDashboardBasedOnPeriod (curChip) {
      // find the period based on selection
      this.enableChip = curChip
      this.fromDate = this.toDate = null
      var curDate = new Date()
      if (curChip === 'Today') {
        this.fromDate = this.toDate = curDate
        this.aDay = true
      } else if (curChip === 'Yesterday') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 1))
        this.toDate = this.fromDate
        this.aDay = true
      } else if (curChip === 'This Week') {
        this.toDate = new Date()
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - (curDate.getDay() - 1)))
        this.aDay = false
      } else if (curChip === 'Last Week') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 7 - (curDate.getDay() - 1)))
        this.toDate = new Date(curDate.setDate(curDate.getDate() + 6))
        this.aDay = false
      } else if (curChip === 'This Month') {
        this.fromDate = new Date(curDate.getFullYear(), curDate.getMonth(), 1)
        this.toDate = curDate
        this.aDay = false
      } else if (curChip === 'Last Month') {
        curDate.setDate(1)
        this.fromDate = new Date(curDate.setMonth(curDate.getMonth() - 1))
        this.toDate = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0)
        this.aDay = false
      } else {
        if (this.periodTo < this.periodFrom) {
          this.msg('From date has to be less than or equal to To date', 0)
          return
        }
        this.fromDate = new Date(this.periodFrom)
        this.toDate = new Date(this.periodTo)
        this.aDay = this.periodFrom === this.periodTo
      }
      // derive the trend
      if (this.aDay) {
        this.trendFrom = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), 1)
        this.trendTo = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth() + 1, 0)
      } else {
        this.trendFrom = this.fromDate
        this.trendTo = this.toDate
      }
      // convert the period into required format
      this.fromDate = handy.formatDBDate(this.fromDate)
      this.toDate = handy.formatDBDate(this.toDate)
      this.trendFrom = handy.formatDBDate(this.trendFrom)
      this.trendTo = handy.formatDBDate(this.trendTo)
      // refresh the dashboard
      this.loadDailyDashboardSummary()
    },
    loadAttChart () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: this.trendFrom,
          to_dt: this.trendTo,
          group_by: 'date',
          is_billable: 1
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getAttendanceRep/', qry)
      .then(response => {
        var dtLbl = [] // x-axis dates
        var avgVal = []
        var totPr = 0
        var totFL = 0
        var totLeave = 0
        var totWO = 0
        var totOT = 0
        var totPend = 0
        var totStaff = 0
        var totHoliday = 0
        // trend chart
        for (var i = 0; i < response.data.length; i++) {
          // pre-processing
          response.data[i].tot_present = response.data[i].tot_present + (response.data[i].tot_hd / 2)
          response.data[i].tot_absent = response.data[i].tot_absent + (response.data[i].tot_hd / 2)
          // for graph
          dtLbl[i] = handy.formatDBDate(response.data[i].att_dt)
          avgVal[i] = Math.round((response.data[i].tot_present + response.data[i].tot_wo + response.data[i].tot_ot + response.data[i].tot_hd) / response.data[i].total_staff * 100)
          // for dashboard summary
          if (response.data[i].total_staff) {
            totStaff += response.data[i].total_staff
          }
          if (response.data[i].tot_present) {
            totPr += response.data[i].tot_present
          }
          if (response.data[i].tot_absent) {
            totFL += response.data[i].tot_absent
          }
          if (response.data[i].tot_leave) {
            totLeave += response.data[i].tot_leave
          }
          if (response.data[i].tot_wo) {
            totWO += response.data[i].tot_wo
          }
          if (response.data[i].tot_ot) {
            totOT += response.data[i].tot_ot
          }
          if (response.data[i].tot_holiday) {
            totHoliday += response.data[i].tot_holiday
          }
          if (response.data[i].tot_pend) {
            totPend += response.data[i].tot_pend
          }
        }
        // summary
        if (this.aDay) {
          // find out the values of chosen day
          let didx = response.data.findIndex(rec => handy.formatDBDate(rec.att_dt) === handy.formatDBDate(this.fromDate))
          if (didx >= 0) {
            this.lAtt.tot_staff = response.data[didx].total_staff
            this.lAtt.tot_present = response.data[didx].tot_present
            this.lAtt.tot_absent = response.data[didx].tot_absent
            this.lAtt.tot_leave = response.data[didx].tot_leave
            this.lAtt.tot_wo = response.data[didx].tot_wo
            this.lAtt.tot_holiday = response.data[didx].tot_holiday
            this.lAtt.tot_ot = response.data[didx].tot_ot
            this.lAtt.tot_pend = response.data[didx].tot_pend
            this.lAtt.attAve = Math.round((this.lAtt.tot_present + this.lAtt.tot_wo + this.lAtt.tot_ot + this.lAtt.tot_holiday) / this.lAtt.tot_staff * 100)
          }
        } else {
          this.lAtt.tot_staff = totStaff
          this.lAtt.tot_present = totPr
          this.lAtt.tot_absent = totFL
          this.lAtt.tot_leave = totLeave
          this.lAtt.tot_wo = totWO
          this.lAtt.tot_holiday = totHoliday
          this.lAtt.tot_ot = totOT
          this.lAtt.tot_pend = totPend
          this.lAtt.attAve = Math.round((totPr + totWO + totOT + totHoliday) / totStaff * 100)
        }
        // reset for next date
        var dsets = []
        dsets[0] = {
          label: 'Attendance %',
          borderColor: 'rgba(0,0,255,0.8)',
          data: avgVal,
          fill: false
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_attend').innerHTML = '<canvas id="chart_attend"></canvas>'
          var canvas = document.getElementById('chart_attend')
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showAttendanceSummary () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: this.aDay ? this.fromDate : this.trendFrom,
          to_dt: this.aDay ? this.fromDate : this.trendTo,
          group_by: 'role',
          is_billable: 1
        }
      }
      this.attReport = []
      this.axios.get(config.SMARTILITY_API_URL + '/getAttendanceRep/', qry)
      .then(response => {
        this.attReport = response.data
        // calculate few fields
        this.attReport.forEach(rec => {
          rec.staff_role = rec.staff_role + ' [' + rec.role_count + ']'
          rec.tot_present = rec.tot_present + (rec.tot_hd / 2)
          rec.tot_absent = rec.tot_absent + (rec.tot_hd / 2)
        })
        this.showSummary = true
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadWaterLevelChart () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterLevelChartDetailsByCommId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var watTypeLbl = []
        var levelVal = {}
        var gw = 0
        var dtLbl = [] // for trend chart
        var levelAvgVal = {}
        var waterLvlKl = {}
        var gd = 0
        var idx = 0
        for (var i = 0; i < resObj.length; i++) {
          watTypeLbl[gw] = resObj[i].storage_nm
          levelVal[gw] = []
          levelAvgVal[gw] = []
          idx = gw++
          var lvl = resObj[i].levels
          for (var d = 0; d < lvl.length; d++) {
            if (lvl[d].water_level === '') {
              lvl[d].water_level = 0
            }
            var didx = dtLbl.indexOf(handy.formatDate(lvl[d].c_date))
            if (didx < 0 && lvl[d].c_date) {
              dtLbl[gd] = handy.formatDate(lvl[d].c_date)
              didx = gd++
            }
            if (this.aDay) {
              if (dtLbl[didx] === handy.formatDate(this.fromDate)) {
                if (lvl[d].water_level) {
                  levelVal[idx][i] = lvl[d].water_level // show specific data for the day in first graph in case of single date
                }
              }
              if (lvl[d].water_level_kl) {
                waterLvlKl[i] = lvl[d].water_level_kl + ' KL'
              }
            } else {
              if (levelVal[idx][i] === undefined) {
                levelVal[idx][i] = 0
              }
              levelVal[idx][i] += Number(lvl[d].water_level)
            }
            if (levelAvgVal[idx][didx] === undefined) {
              levelAvgVal[idx][didx] = 0
            }
            levelAvgVal[idx][didx] = Number(lvl[d].water_level)
          }
          if (!this.aDay) {
            levelVal[idx][i] /= lvl.length // show average in first graph in case of period
            levelVal[idx][i] = levelVal[idx][i].toFixed(0)
          }
        }
        for (var j = 0; j < watTypeLbl.length; j++) {
          // shorten the label
          if (watTypeLbl[j].length > 3) {
            watTypeLbl[j] = watTypeLbl[j].substring(0, 10)
          }
        }
        // chart 1
        // data set
        // data set
        var value = []
        for (i = 0; i < watTypeLbl.length; i++) {
          value.push(levelVal[i][i])
        }
        // clear the content if any
        document.getElementById('div_watlvl').innerHTML = '<canvas id="chart_watlvl"></canvas>'
        var canvas = document.getElementById('chart_watlvl')
        canvas.height = watTypeLbl.length > 2 ? watTypeLbl.length * 30 : watTypeLbl.length * 50
        var ctx = canvas.getContext('2d')
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: watTypeLbl,
            datasets: [{
              backgroundColor: 'rgba(' + COLORS[1] + ',0.7)',
              data: value,
              fill: true
            }]
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value + '%' || ''
                },
                color: '#ffffff'
              }
            },
            tooltips: {enabled: false},
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  min: 0
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })

        // chart 2
        var dsets2 = []
        for (i = 0; i < watTypeLbl.length; i++) {
          dsets2[i] = {
            label: watTypeLbl[i] + ' (%)',
            backgroundColor: 'rgba(' + COLORS[1] + ',0.1)',
            borderColor: 'rgba(' + COLORS[i] + ',1)',
            data: levelAvgVal[i],
            fill: true
          }
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_watlvltrend').innerHTML = '<canvas id="chart_watlvltrend"></canvas>'
          canvas = document.getElementById('chart_watlvltrend')
          var ctx2 = canvas.getContext('2d')

          this.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWaterConsType () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterStorageByCommId/', qry)
      .then(response => {
        this.waterConsTypeList = response.data.map(rec => rec.storage_nm)
        this.waterConsType = this.waterConsTypeList[0]
        // water level trend over a day
        this.storageNmListWithWaterLvl = response.data.filter(rec => rec.is_level_checked === 1)
        if (this.storageNmListWithWaterLvl.length > 0) {
          this.selectedStorageNmWithWaterLvl = this.storageNmListWithWaterLvl[0].storage_id
        }
        // water consumption trend over a day
        this.storageNmListWithWaterCons = response.data.filter(rec => rec.is_receipt_checked === 1 || rec.is_cons_checked === 1)
        if (this.storageNmListWithWaterCons.length > 0) {
          this.selectedStorageNmWithWaterCons = this.storageNmListWithWaterCons[0].storage_id
        }
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadWaterConsChart () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: this.trendFrom,
          to_dt: this.trendTo,
          comingFrom: 'Facdash',
          water_cat: this.choosenType
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterConsChartDetailsByCommId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var watTypeLbl = []
        var recVal = {}
        var dtLbl = [] // for trend chart
        var recAvgVal = {}
        var didx = 0
        var widx = 0
        var custWatType = this.waterConsType
        var modeLbl = ['Received (KL)', 'Consumed (KL)']
        recVal[0] = []
        recVal[1] = []
        recAvgVal[0] = []
        recAvgVal[1] = []
        this.tankerVal = 0
        this.receivedVal = 0
        this.consumedVal = 0
        for (var r = 0; r < resObj.length; r++) {
          var cons = resObj[r].cons
          for (var d = 0; d < cons.length; d++) {
            didx = dtLbl.indexOf(handy.formatDBDate(cons[d].c_date))
            if (didx < 0 && cons[d].c_date) {
              didx = dtLbl.length
              dtLbl[didx] = handy.formatDBDate(cons[d].c_date)
            }
            widx = watTypeLbl.indexOf(resObj[r].storage_nm.substring(0, 10))
            if (widx < 0) {
              widx = watTypeLbl.length
              watTypeLbl[widx] = resObj[r].storage_nm.substring(0, 10)
            }
            if (this.aDay) {
              // show specefic data for the day in first graph in case of single date
              if (dtLbl[didx] === handy.formatDBDate(this.fromDate)) {
                if (!recVal[0][widx]) {
                  recVal[0][widx] = 0
                }
                if (cons[d].water_receipt) {
                  this.receivedVal += cons[d].water_receipt
                }
                recVal[0][widx] += cons[d].water_cons
              }
            } else {
              if (!recVal[0][widx]) {
                recVal[0][widx] = 0
              }
              if (cons[d].water_receipt) {
                this.receivedVal += cons[d].water_receipt
              }
              recVal[0][widx] += Number(cons[d].water_cons)
              recVal[1][widx] += Number(cons[d].water_receipt)
            }
            // worry about trend of only user chosen water type
            if (custWatType === resObj[r].storage_nm) {
              if (recAvgVal[0][didx] === undefined || recAvgVal[1][didx] === undefined) {
                recAvgVal[0][didx] = 0
                recAvgVal[1][didx] = 0
              }
              recAvgVal[0][didx] += Number(cons[d].water_receipt)
              recAvgVal[1][didx] += Number(cons[d].water_cons)
            }
          }
        }
        // to do: when automated for mulitple timestamps on the same day
        // chart 1 (water receipt and cons)
        // data set
        var dsets = []
        for (var j = 0; j < recVal[0].length; j++) {
          recVal[0][j] = recVal[0][j] > 0 ? recVal[0][j].toFixed(2) : 0
          this.consumedVal += Number(recVal[0][j])
        }
        dsets[0] = {
          label: modeLbl[1],
          backgroundColor: 'rgba(' + COLORS[4] + ',0.7)',
          borderColor: 'rgba(' + COLORS[4] + ',1)',
          data: recVal[0],
          fill: true
        }
        // clear the content if any
        document.getElementById('div_watcons').innerHTML = '<canvas id="chart_watcons"></canvas>'
        var canvas = document.getElementById('chart_watcons')
        canvas.height = watTypeLbl.length > 4 ? watTypeLbl.length * 30 : watTypeLbl.length * 50
        var ctx = canvas.getContext('2d')
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: watTypeLbl,
            datasets: dsets
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value > 0 ? value + ' KL' : ''
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          }
        })
        // chart 2 (trend)
        var dsets2 = []
        for (var i = 0; i < modeLbl.length; i++) {
          for (j = 0; j < recAvgVal[i].length; j++) {
            recAvgVal[i][j] = recAvgVal[i][j] > 0 ? recAvgVal[i][j].toFixed(2) : 0
          }
          dsets2[i] = {
            label: modeLbl[i],
            backgroundColor: 'rgba(' + COLORS[(i === 0 ? i + 2 : i + 3)] + ',0.1)',
            borderColor: 'rgba(' + COLORS[(i === 0 ? i + 2 : i + 3)] + ',1)',
            data: recAvgVal[i],
            fill: false
          }
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_watconstrend').innerHTML = '<canvas id="chart_watconstrend"></canvas>'
          canvas = document.getElementById('chart_watconstrend')
          var ctx2 = canvas.getContext('2d')
          this.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWaterQualChart () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getDailyWaterQualityByCommId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var paramLbl = []
        var paramId = []
        var paramUoM = []
        var watTypeLbl = []
        var qualVal = {}
        var stdValMin = []
        var stdValMax = []
        var dtLbl = [] // for trend chart
        var avgWaterLbl = []
        var qualAvgVal = {}
        var didx = 0
        var widx = 0
        var pidx = 0
        var apidx = 0
        var dtIdx = 1
        var x = 0
        var custParamName = this.waterQualType
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(handy.formatDBDate(resObj[r].c_date))

          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length
            dtLbl[didx] = handy.formatDBDate(resObj[r].c_date)
          }

          widx = watTypeLbl.indexOf(resObj[r].water_type)
          if (widx < 0) {
            widx = watTypeLbl.length
            watTypeLbl[widx] = resObj[r].water_type
            qualVal[widx] = []
          }

          pidx = paramId.indexOf(resObj[r].param_id)
          if (pidx < 0) {
            pidx = paramId.length
            paramId[pidx] = resObj[r].param_id
            paramLbl[pidx] = resObj[r].param_name
            qualAvgVal[pidx] = []
          }
          if (this.aDay) {
            // show specefic data for the day in first graph in case of single date - overwrite to latest value if multiple log is found
            if (dtLbl[didx] === this.fromDate) {
              qualVal[widx][pidx] = Number(resObj[r].val)
            }
          } else {
            if (qualVal[widx][pidx] === undefined) {
              qualVal[widx][pidx] = 0
            }
            qualVal[widx][pidx] += Number(resObj[r].val)
          }
          paramUoM[pidx] = resObj[r].uom
          stdValMin[pidx] = Number(resObj[r].std_val_min)
          stdValMax[pidx] = Number(resObj[r].std_val_max)

          // worry about trend of only user chosen parameter
          if (custParamName === resObj[r].param_name) {
            apidx = avgWaterLbl.indexOf(resObj[r].water_type)
            if (apidx < 0) {
              apidx = avgWaterLbl.length
              avgWaterLbl[apidx] = resObj[r].water_type
              qualAvgVal[apidx] = []
            }

            qualAvgVal[apidx][didx] = Number(resObj[r].val)
          }
        }
        // find ave
        if (!this.aDay) {
          for (var i = 0; i < watTypeLbl.length; i++) {
            for (var j = 0; j < paramLbl.length; j++) {
              if (qualVal[i][j] && qualVal[i][j] !== '  ') {
                x = resObj.filter(rec => rec.param_name === paramLbl[j]).length
                if (x > 1) {
                  qualVal[i][j] /= x
                }
                qualVal[i][j] = (Number.isInteger(qualVal[i][j]) || qualVal[i][j] > 50) ? qualVal[i][j].toFixed(0) : qualVal[i][j].toFixed(1)
              }
            }
          }
        }
        // chart 1
        this.watQualHead = [
          { text: 'PARAM', value: 'param_name', class: 'grey darken-1 white--text text-center' }
        ]
        // params
        this.waterQualParamList = paramLbl
        if (!this.waterQualType) {
          this.waterQualType = this.waterQualParamList[0]
        }
        this.watList = []
        var minMax = ''
        for (i = 0; i < paramLbl.length; i++) {
          if (stdValMin[i] && stdValMax[i]) {
            minMax = stdValMin[i] + ' to ' + stdValMax[i]
          } else if (stdValMin[i]) {
            minMax = 'min ' + stdValMin[i]
          } else {
            minMax = 'max ' + stdValMax[i]
          }
          this.watList.push({
            param_name: paramLbl[i],
            param_value: '(' + paramUoM[i] + ') [' + minMax + ']',
            std_val_min: stdValMin[i],
            std_val_max: stdValMax[i],
            waterQualTypeValue: []
          })
        }
        // construct table headers dynamically
        for (i = 0; i < watTypeLbl.length; i++) {
          this.watQualHead.splice(dtIdx++, 0,
            {
              text: watTypeLbl[i] === 'SWIMMING POOL' ? 'S. POOL' : watTypeLbl[i], value: watTypeLbl[i], class: 'pl-2 pr-0 text-center white--text ccolor' + (i + 1)
            }
          )
        }
        // construct value table for each parameter

        for (i = 0; i < paramLbl.length; i++) {
          for (j = 0; j < watTypeLbl.length; j++) {
            this.watList[i].waterQualTypeValue.push({
              val: qualVal[j][i] || ''
            })
          }
        }
        dtLbl.forEach(rec => {
          if (rec.length === 0) {
            qualAvgVal = {}
          }
        })
        this.waterTypeLebel = watTypeLbl
        // chart 2
        var watColor = 0
        var dsets2 = []
        for (i = 0; i < avgWaterLbl.length; i++) {
          watColor = watTypeLbl.indexOf(avgWaterLbl[i])
          dsets2[i] = {
            label: avgWaterLbl[i],
            backgroundColor: 'rgba(' + COLORS[watColor] + ', 0.1)',
            borderColor: 'rgba(' + COLORS[watColor] + ', 1)',
            data: qualAvgVal[i],
            fill: false
          }
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_watqualtrend').innerHTML = '<canvas id="chart_watqualtrend"></canvas>'
          var canvas = document.getElementById('chart_watqualtrend')
          var ctx2 = canvas.getContext('2d')
          this.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWaterSources () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          c_date: handy.formatDBDate(this.fromDate),
          from_dt: this.fromDate,
          to_dt: this.toDate
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterSourcesByCommIdAndcDate/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.domWatList = response.data
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWaterConsumptionBasedonChip (curChip) {
      this.choosenType = curChip
      this.loadWaterConsChart()
    },
    loadPowerConsChart () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getPowerConsChartDetailsByCommId/', qry)
      .then(response => {
        var resObjPow = response.data.filter(rec => rec.power_unit_cons !== -1)
        var resObjGen = response.data.filter(rec => rec.genset_unit_cons !== -1)
        var dtLbl = [] // for trend chart
        var recTrendVal = {}
        var recVal = 0
        recTrendVal[0] = []
        recTrendVal[1] = []
        recTrendVal[2] = []
        var powUnits = 0
        var genUnits = 0
        var totPowUnits = 0
        var totGenUnits = 0
        for (var r = 0; r < resObjPow.length; r++) {
          dtLbl[r] = handy.formatDBDate(resObjPow[r].c_date)
          recTrendVal[0][r] = Number(resObjPow[r].power_unit_cons)

          if (this.aDay) {
            // show specefic data for the day in section 1
            if (dtLbl[r] === handy.formatDBDate(this.fromDate)) {
              powUnits = Number(resObjPow[r].power_unit_cons)
            }
          } else {
            recVal = recVal + Number(resObjPow[r].power_unit_cons)
            totPowUnits = totPowUnits + Number(resObjPow[r].power_unit_cons)
          }
        } // for every rec
        // genset
        for (r = 0; r < resObjGen.length; r++) {
          dtLbl[r] = handy.formatDBDate(resObjGen[r].c_date)
          recTrendVal[1][r] = Number(resObjGen[r].genset_unit_cons)
          if (this.aDay) {
            // show specefic data for the day in section 1
            if (dtLbl[r] === this.fromDate) {
              genUnits = Number(resObjGen[r].genset_unit_cons)
            }
          } else {
            recVal = recVal + Number(resObjGen[r].genset_unit_cons)
            totGenUnits = totGenUnits + Number(resObjGen[r].genset_unit_cons)
          }
        } // for every rec
        if (this.aDay) {
          this.powCons = powUnits
          this.genCons = genUnits
        } else {
          this.powCons = totPowUnits
          this.genCons = totGenUnits
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_powconstrend').innerHTML = '<canvas id="chart_powconstrend"></canvas>'
          var canvas = document.getElementById('chart_powconstrend')
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: [
                {
                  label: 'Electricity Board (units)',
                  backgroundColor: 'rgba(' + COLORS[2] + ',0.4)',
                  borderColor: 'rgba(' + COLORS[2] + ',1)',
                  data: recTrendVal[0],
                  fill: true
                },
                {
                  label: 'Genset (units)',
                  backgroundColor: 'rgba(' + COLORS[4] + ',0.4)',
                  borderColor: 'rgba(' + COLORS[4] + ',1)',
                  data: recTrendVal[1],
                  fill: false
                }
              ]
            },
            options: {
              plugins: {
                datalabels: {
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadDieselConsChart () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getPowerGensetByCommIdAndcDate/', qry)
      .then(response => {
        var resObj = response.data
        var modeLbl = ['Level (%)', 'Purchased (ltr)', 'Stock (ltr)']
        var genLbl = []
        var levelVal = {}
        var dtLbl = [] // for trend chart
        var recAvgVal = {}
        var didx = 0
        var gidx = 0
        var purVal = 0
        var stkVal = 0
        levelVal[0] = []
        levelVal[1] = []
        recAvgVal[0] = []
        recAvgVal[1] = []
        recAvgVal[2] = []
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(handy.formatDBDate(resObj[r].c_date))
          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length
            dtLbl[didx] = handy.formatDBDate(resObj[r].c_date)
          }

          gidx = genLbl.indexOf(resObj[r].genset_nm)
          if (gidx < 0) {
            gidx = genLbl.length
            genLbl[gidx] = resObj[r].genset_nm
            levelVal[0][gidx] = 0
            levelVal[1][gidx] = 0
          }

          if (this.aDay) {
            // show specefic data for the day in section 1 (badge)
            if (dtLbl[didx] === handy.formatDBDate(this.fromDate)) {
              levelVal[0][gidx] = Number(resObj[r].level)
              purVal += Number(resObj[r].purchased)
              stkVal += Number(resObj[r].stock)
            }
          } else {
            levelVal[0][gidx] += Number(resObj[r].level)
            purVal += Number(resObj[r].purchased)
            stkVal += Number(resObj[r].stock)
          }

          if (recAvgVal[0][didx] === undefined || recAvgVal[1][didx] === undefined || recAvgVal[2][didx] === undefined) {
            recAvgVal[0][didx] = 0
            recAvgVal[1][didx] = 0
            recAvgVal[2][didx] = 0
          }
          recAvgVal[0][didx] += Number(resObj[r].level) // total of all genset, average found later
          recAvgVal[1][didx] += Number(resObj[r].purchased)
          recAvgVal[2][didx] += Number(resObj[r].stock)
        } // for every rec
        // find ave
        if (!this.aDay) {
          // ave for level and stock only
          for (var i = 0; i < genLbl.length; i++) {
            levelVal[0][i] /= dtLbl.length
            levelVal[0][i] = levelVal[0][i].toFixed(0)
          }
          stkVal /= dtLbl.length
          stkVal = stkVal.toFixed(0)
        }
        // average for level in second graph
        for (i = 0; i < dtLbl.length; i++) {
          recAvgVal[0][i] /= genLbl.length
          recAvgVal[0][i] = recAvgVal[0][i].toFixed(0)
        }
        dtLbl.forEach(rec => {
          if (rec.length <= 0) {
            recAvgVal = {}
          }
        })
        // section 1
        // 1. cons
        this.diCons = purVal
        this.diStock = stkVal

        // 2. level
        // data set
        // clear the content if any
        document.getElementById('div_dicons').innerHTML = '<canvas id="chart_dicons"></canvas>'
        var canvas = document.getElementById('chart_dicons')
        var ctx = canvas.getContext('2d')
        this.tmpChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: genLbl,
            datasets: [{
              label: modeLbl[0],
              backgroundColor: 'rgba(' + COLORS[3] + ',0.7)',
              borderColor: 'rgba(' + COLORS[3] + ',1)',
              data: levelVal[0],
              fill: true
            }]
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value > 0 ? value + ' %' : ''
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          }
        })
        // chart 2
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_diconstrend').innerHTML = '<canvas id="chart_diconstrend"></canvas>'
          canvas = document.getElementById('chart_diconstrend')
          var ctx2 = canvas.getContext('2d')
          this.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: [{
                label: modeLbl[0],
                backgroundColor: 'rgba(' + COLORS[3] + ',0.4)',
                borderColor: 'rgba(' + COLORS[3] + ',1)',
                data: recAvgVal[0],
                fill: true
              },
              {
                label: modeLbl[1],
                backgroundColor: 'rgba(' + COLORS[2] + ',0.4)',
                borderColor: 'rgba(' + COLORS[2] + ',1)',
                data: recAvgVal[1],
                fill: false
              },
              {
                label: modeLbl[2],
                backgroundColor: 'rgba(' + COLORS[4] + ',0.4)',
                borderColor: 'rgba(' + COLORS[4] + ',1)',
                data: recAvgVal[2],
                fill: false
              }]
            },
            options: {
              plugins: {
                datalabels: {
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWasteChart () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWasteByCommIdAndcDate/', qry)
      .then(response => {
        var resObj = response.data
        var wasteTypeLbl = []
        var recVal = {}
        var dtLbl = [] // for trend chart
        var recAvgVal = {}
        var didx = 0
        var widx = 0

        recVal[0] = []
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(handy.formatDBDate(resObj[r].c_date))

          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length
            dtLbl[didx] = handy.formatDBDate(resObj[r].c_date)
          }

          widx = wasteTypeLbl.indexOf(resObj[r].waste_type)
          if (widx < 0) {
            widx = wasteTypeLbl.length
            wasteTypeLbl[widx] = resObj[r].waste_type
            recVal[widx] = []
            recAvgVal[widx] = []
          }
          if (this.aDay) {
            // show specefic data for the day in first graph in case of single date
            if (dtLbl[didx] === handy.formatDBDate(this.fromDate)) {
              recVal[widx][0] = resObj[r].kgs
            }
          } else {
            if (recVal[widx][0] === undefined) {
              recVal[widx][0] = 0
            }
            recVal[widx][0] += Number(resObj[r].kgs)
          }
          // for trend
          if (recAvgVal[widx][didx] === undefined) {
            recAvgVal[widx][didx] = 0
          }
          recAvgVal[widx][didx] += resObj[r].kgs
        } // for every rec
        // chart 1
        // data set
        var dsets = []
        var lColor = ['0,255,0', '0,0,255', '255,0,0']
        for (var i = 0; i < wasteTypeLbl.length; i++) {
          dsets[i] = {
            label: wasteTypeLbl[i] + ' (kg)',
            backgroundColor: 'rgba(' + lColor[i] + ',0.4)',
            borderColor: 'rgba(' + lColor[i] + ',1)',
            data: recVal[i],
            fill: true
          }
        }
        // clear the content if any
        document.getElementById('div_waste').innerHTML = '<canvas id="chart_waste"></canvas>'
        var canvas = document.getElementById('chart_waste')
        var ctx = canvas.getContext('2d')
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: ['Wastage (kg)'],
            datasets: dsets
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value > 0 ? value + ' Kg' : ''
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  min: 0
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })

        // chart 2
        var dsets2 = []
        for (i = 0; i < wasteTypeLbl.length; i++) {
          dsets2[i] = {
            label: wasteTypeLbl[i] + ' (kg)',
            backgroundColor: 'rgba(' + lColor[i] + ',0.1)',
            borderColor: 'rgba(' + lColor[i] + ',1)',
            data: recAvgVal[i],
            fill: false
          }
        }
        if (this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_wastetrend').innerHTML = '<canvas id="chart_wastetrend"></canvas>'
          canvas = document.getElementById('chart_wastetrend')
          var ctx2 = canvas.getContext('2d')
          this.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadCustomMetricCat () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getCusMetByCommId/', qry)
      .then(response => {
        this.metricCat = handy.unique(response.data.map(rec => rec.metric_cat))
      })
      .catch(err => {
        this.msg(err, true)
        this.metricCat = []
      })
    },
    loadOtherCustomMetricChart () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getMetricByCommId/', qry)
      .then(response => {
        var prevCat = ''
        var curCat = ''
        var curCatNoSpace = ''
        var resObj = response.data
        var idx = 0
        for (var i = 0; i < resObj.length; i = idx) {
          curCat = resObj[i].metric_cat
          prevCat = curCat
          curCatNoSpace = curCat.split(' ').join('_')
          var metNameLbl = []
          var totOrAve = []
          var recVal = []
          var dtLbl = [] // for trend chart
          var recAvgVal = {}
          var didx = 0
          var widx = 0

          recVal[0] = []
          for (var r = i; r < resObj.length; r++) {
            curCat = resObj[r].metric_cat
            if (curCat !== prevCat) {
              idx = r // finish this category and move to next category
              break
            } else {
              idx++
            }

            didx = dtLbl.indexOf(handy.formatDBDate(resObj[r].c_date))

            if (didx < 0 && resObj[r].c_date) {
              didx = dtLbl.length
              dtLbl[didx] = handy.formatDBDate(resObj[r].c_date)
            }
            widx = metNameLbl.indexOf(resObj[r].metric_nm)
            if (widx < 0) {
              widx = metNameLbl.length
              metNameLbl[widx] = resObj[r].metric_nm
              recVal[widx] = []
              totOrAve[widx] = resObj[r].period_display
              recAvgVal[widx] = []
            }
            if (this.aDay) {
              // show specefic data for the day in first graph in case of single date
              if (dtLbl[didx] === handy.formatDBDate(this.fromDate)) {
                recVal[widx][0] = resObj[r].metric_val
              }
            } else {
              if (!recVal[widx][0]) {
                recVal[widx][0] = 0
              }
              recVal[widx][0] += Number(resObj[r].metric_val)
            }
            // for trend
            if (!recAvgVal[widx][didx]) {
              recAvgVal[widx][didx] = 0
            }
            recAvgVal[widx][didx] += resObj[r].metric_val
          } // for every rec
          dtLbl.forEach(rec => {
            if (rec.length <= 0) {
              recAvgVal = {}
            }
          })
          // chart 1
          // data set
          var dsets = []
          for (var c = 0; c < metNameLbl.length; c++) {
            // find avarage if this metric is configured to be displayed as average
            if (!this.aDay && totOrAve[c] === 'A') {
              recVal[c][0] /= dtLbl.length
              recVal[c][0] = recVal[c][0].toFixed(0)
              metNameLbl[c] = metNameLbl[c] + ' (Avg)'
            } else if (!this.aDay) {
              metNameLbl[c] = metNameLbl[c] + ' (Tot)'
            }
            dsets[c] = {
              label: metNameLbl[c],
              backgroundColor: 'rgba(' + COLORS[c % 5] + ',0.4)',
              borderColor: 'rgba(' + COLORS[c % 5] + ',1)',
              data: recVal[c],
              fill: true
            }
          }
          // clear the content if any
          document.getElementById('div_other_' + curCatNoSpace).innerHTML = '<canvas id="chart_other_' + curCatNoSpace + '"></canvas>'
          var canvas = document.getElementById('chart_other_' + curCatNoSpace)
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: [''],
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return value > 0 ? value : ''
                  },
                  color: '#ffffff'
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
          // chart 2
          var dsets2 = []
          for (var j = 0; j < metNameLbl.length; j++) {
            dsets2[j] = {
              label: metNameLbl[j],
              backgroundColor: 'rgba(' + COLORS[j % 5] + ',0.1)',
              borderColor: 'rgba(' + COLORS[j % 5] + ',1)',
              data: recAvgVal[j],
              fill: false
            }
          }
          if (this.enableTrend === true) {
            // clear the content if any
            document.getElementById('div_other_trend_' + curCatNoSpace).innerHTML = '<canvas id="chart_other_trend_' + curCatNoSpace + '"></canvas>'
            canvas = document.getElementById('chart_other_trend_' + curCatNoSpace)
            var ctx2 = canvas.getContext('2d')
            this.tmpChart2 = new Chart(ctx2, {
              type: 'line',
              data: {
                labels: dtLbl,
                datasets: dsets2
              },
              options: {
                plugins: {
                  datalabels: {
                    display: false
                  }
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                  display: false
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true
                    }
                  }]
                }
              }
            })
          }
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    EnableTrend () {
      if (!this.enableTrend) {
        this.enableTrend = true
      } else {
        this.enableTrend = false
      }
      this.loadDailyDashboardSummary()
      this.$forceUpdate()
    },
    loadFacDailyUpdateAttachment () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: this.aDay && !this.enableTrend ? this.fromDate : this.trendFrom,
          to_dt: this.aDay && !this.enableTrend ? this.toDate : this.trendTo
        }
      }
      this.lDailyUpdateAttach.fileUrls = []
      this.lDailyUpdateAttach.files = []
      this.axios.get(config.SMARTILITY_API_URL + '/getAttachmentByCDate/', qry)
      .then(response => {
        this.lDailyUpdateAttach.fileUrls = response.data
        this.lDailyUpdateAttach.cat = this.lDailyUpdateAttach.cat || 'All'
        if (this.lDailyUpdateAttach.cat === 'All') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls
        } else {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === this.lDailyUpdateAttach.cat)
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.lDailyUpdateAttach.fileUrls = []
      })
    },
    loadCategoryImage (curcategory) {
      if (curcategory) {
        this.lDailyUpdateAttach.files = []
        this.lDailyUpdateAttach.cat = curcategory
        if (curcategory === 'All') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls
        } else {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === curcategory)
        }
        this.$forceUpdate()
      }
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommunityByVendorId/' , qry)
      .then(response => {
        this.commList = response.data
        // this.lDashBoard.comm_id = this.commList[0].comm_id // first community by default
        this.lDashBoard.comm_id = this.commList[0].comm_id // first community by default
        this.loadDashboardBasedOnPeriod('Yesterday')
      })
      .catch(err => {
        this.msg(err.response.data)
        this.commList = []
      })
    },
    loadPhotoCat () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getPhotoCatByCommId/', qry)
      .then(response => {
        this.photoCatChips = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadTrendOverADayBasedOnPeriod (curChip, curType, curWatType) {
      if (this.aDay) {
        if (curWatType) {
          this.waterQualiltyType = curWatType
        }
        // find the period based on selection
        this.enableTrendChip = curChip
        this.fromTime = this.toTime = null
        var curDate = new Date()
        if (curChip === 'Last 1 hr') {
          this.fromTime = handy.getTime(new Date(curDate.getTime() - (1000 * 60 * 60)))
          this.toTime = handy.getTime(new Date(curDate.getTime()))
        } else if (curChip === '6 hrs') {
          this.fromTime = handy.getTime(new Date(curDate.getTime() - (1000 * 60 * 60 * 6)))
          this.toTime = handy.getTime(new Date(curDate.getTime()))
        } else if (curChip === '12 hrs') {
          this.fromTime = handy.getTime(new Date(curDate.getTime() - (1000 * 60 * 60 * 12)))
          this.toTime = handy.getTime(new Date(curDate.getTime()))
        } else {
          this.fromTime = '00:00:00'
          this.toTime = '23:59:59'
        }
        // if fromtime is greater than toTime
        if (this.fromTime > this.toTime) {
          this.fromTime = '00:00:00'
        }
        // common values for quality and level
        if (this.enableChip === 'Yesterday') {
          this.fromDt = new Date(curDate.setDate(curDate.getDate() - 1))
          this.toDt = this.fromDt
        } else if (this.enableChip === 'Today') {
          this.fromDt = this.toDt = curDate
        } else if (this.enableChip === 'Period') {
          this.fromDt = this.fromDate
          this.toDt = this.toDate
        }
        // refresh the Trend over a day graph
        if (curType === 'Quality') {
          this.showWaterQualityOverADay()
        } else if (curType === 'Level') {
          this.showWaterLevelOverADay()
        } else if (curType === 'Cons') {
          this.showWaterConsOverADay()
        }
      }
      if (curType === 'Power') {
        this.showPowerConsPieChart()
      }
    },
    showWaterQualityOverADay () {
      if (!this.waterQualiltyType) {
        this.waterQualiltyType = this.waterQualParamList[0]
      }

      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: handy.formatDBDate(this.fromDt),
          to_dt: handy.formatDBDate(this.toDt),
          from_time: this.fromTime,
          to_time: this.toTime
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterQualityBasedOnADay/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var dtLbl = []
        var watQualAvgVal = []
        var paramNameLbl = []
        var avgWaterLbl = []
        var gd = 0
        var apidx = 0
        var custParamName = this.waterQualiltyType
        // trend chart
        for (var i = 0; i < resObj.length; i++) {
          // for every rec
          paramNameLbl[i] = resObj[i].param_name
          watQualAvgVal[i] = []
          // for graph
          var lvl = resObj[i].value
          for (var d = 0; d < lvl.length; d++) {
            if (lvl[d].val === '') {
              lvl[d].val = 0
            }
            // worry about trend of only user chosen parameter
            if ((custParamName === resObj[i].param_name)) {
              var didx = dtLbl.indexOf(handy.getTime12Hrs(lvl[d].c_date))
              if (didx < 0 && lvl[d].c_date) {
                dtLbl[gd] = handy.getTime12Hrs(lvl[d].c_date)
                didx = gd++
              }
              apidx = avgWaterLbl.indexOf(resObj[i].water_type)
              if (apidx < 0) {
                apidx = avgWaterLbl.length
                avgWaterLbl[apidx] = resObj[i].water_type
              }
              watQualAvgVal[apidx][didx] = Number(lvl[d].val)
            }
          }
        }
        for (var j = 0; j < paramNameLbl.length; j++) {
          // shorten the label
          if (paramNameLbl[j].length > 3) {
            paramNameLbl[j] = paramNameLbl[j].substring(0, 10)
          }
        }
        // chart 1
        // data set
        var watColor = 0
        var dsets = []
        for (i = 0; i < avgWaterLbl.length; i++) {
          watColor = this.waterTypeLebel.indexOf(avgWaterLbl[i])
          dsets[i] = {
            label: avgWaterLbl[i],
            backgroundColor: 'rgba(' + COLORS[watColor] + ', 0.1)',
            borderColor: 'rgba(' + COLORS[watColor] + ', 1)',
            data: watQualAvgVal[i],
            fill: false
          }
        }

        // clear the content if any
        setTimeout(() => {
          document.getElementById('div_watqualoveradaytrend').innerHTML = '<canvas id="chart_watqualoveradaytrend"></canvas>'
          var canvas = document.getElementById('chart_watqualoveradaytrend')
          canvas.height += avgWaterLbl.length * 30
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom'
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }, 500)
        this.qualityTrendOverADay = true
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadselectedStorageNmWithWaterLvl () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterLvlByCommId/', qry)
      .then(response => {
        this.storageNmListWithWaterLvl = response.data
        if (response.data.length > 0) {
          this.selectedStorageNmWithWaterLvl = this.storageNmListWithWaterLvl[0].storage_id
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showWaterLevelOverADay () {
      if (!this.selectedStorageNmWithWaterLvl) {
        this.selectedStorageNmWithWaterLvl = this.storageNmListWithWaterLvl[0].storage_id
      }
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: handy.formatDBDate(this.fromDt) + ' ' + this.fromTime,
          to_dt: handy.formatDBDate(this.toDt) + ' ' + this.toTime,
          storage_id: this.selectedStorageNmWithWaterLvl
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterLevelTrendOverAdayByStorageId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var dtLbl = []
        var watLevelAvgVal = []
        var avgStorageLbl = []
        var gd = 0
        var apidx = 0
        var custStorageId = this.selectedStorageNmWithWaterLvl
        this.watTankBattery = null
        // trend chart
        for (var i = 0; i < resObj.length; i++) {
          watLevelAvgVal[i] = []
          var lvl = resObj[i].levels[0]
          for (var d = 0; d < lvl.length; d++) {
            if (lvl[d].water_level === '') {
              lvl[d].water_level = 0
            }
            // worry about trend of only user chosen parameter
            if (custStorageId === resObj[i].storage_id) {
              if (lvl[d].dev_battery) {
                this.watTankBattery = lvl[d].dev_battery
              }
              var didx = dtLbl.indexOf(handy.getTime12Hrs(lvl[d].c_date))
              if (didx < 0 && lvl[d].c_date) {
                dtLbl[gd] = handy.getTime12Hrs(lvl[d].c_date)
                didx = gd++
              }
              apidx = avgStorageLbl.indexOf(resObj[i].storage_nm)
              if (apidx < 0) {
                apidx = avgStorageLbl.length
                avgStorageLbl[apidx] = resObj[i].storage_nm
              }
              watLevelAvgVal[apidx][didx] = Number(lvl[d].water_level)
            }
          }
        }
        // chart 1
        // data set
        var dsets = []
        for (i = 0; i < avgStorageLbl.length; i++) {
          dsets[i] = {
            label: avgStorageLbl[i],
            backgroundColor: 'rgba(' + COLORS[1] + ',0.5)',
            borderColor: 'rgba(' + COLORS[0] + ', 1)',
            data: watLevelAvgVal[i],
            fill: true
          }
        }
        // clear the content if any
        setTimeout(() => {
          document.getElementById('div_watlvloveradaytrend').innerHTML = '<canvas id="chart_watlvloveradaytrend"></canvas>'
          var canvas = document.getElementById('chart_watlvloveradaytrend')
          canvas.height += avgStorageLbl.length * 30
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }, 500)
        this.lvlTrendOverADay = true
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showPowerConsPieChart () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: handy.formatDBDate(this.fromDt),
          to_dt: handy.formatDBDate(this.toDt)
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getPowerMeterDailyRep/', qry)
      .then(response => {
        var resObj = response.data
        var areaLbl = []
        var unitConsVal = []
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          areaLbl[i] = resObj[i].area_covered
          unitConsVal[i] = 0
          if (!resObj[i].unit_cons) {
            resObj[i].unit_cons = 0
          }
          unitConsVal[i] += Number(resObj[i].unit_cons)
        }
        var totZero = 0
        for (i = 0; i < unitConsVal.length; i++) {
          if (unitConsVal[i] === 0) {
            totZero++
          }
        }
        if (totZero === unitConsVal.length) {
          this.nodata = true
        }
        // chart 1
        // clear the content if any
        if (this.nodata) {
          setTimeout(() => {
            document.getElementById('div_powconstrendoveraday').innerHTML = 'No data available'
          }, 500)
          this.$forceUpdate()
        } else {
          setTimeout(() => {
            document.getElementById('div_powconstrendoveraday').innerHTML = '<canvas id="chart_powconstrendoveraday"></canvas>'
            var canvas = document.getElementById('chart_powconstrendoveraday')
            var ctx = canvas.getContext('2d')
            ctx.canvas.height = areaLbl.length * 18
            ctx.canvas.width = areaLbl.length * 20
            this.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: areaLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429', '#5f4170', '#4c646e'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Electricity Board (Units)'
                },
                legend: {
                  position: 'bottom'
                }
              }
            })
          }, 500)
        }
        this.showPowerConstrendOverADay = true
        this.showPowerGensetPieChart()
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showPowerGensetPieChart () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: handy.formatDBDate(this.fromDt),
          to_dt: handy.formatDBDate(this.toDt)
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getPowerGensetPieChartByCommId/', qry)
      .then(response => {
        var resObj = response.data
        var gensetLbl = []
        var unitConsVal = []
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          gensetLbl[i] = resObj[i].genset_nm
          var unitVal = resObj[i].value
          unitConsVal[i] = 0
          for (var d = 0; d < unitVal.length; d++) {
            if (!unitVal[d].units_cons) {
              unitVal[d].units_cons = 0
            }
            unitConsVal[i] += Number(unitVal[d].units_cons)
          }
        }
        var totZero = 0
        for (i = 0; i < unitConsVal.length; i++) {
          if (unitConsVal[i] === 0) {
            totZero++
          }
        }
        if (totZero === unitConsVal.length) {
          this.nodata = true
        }
        // chart 1
        // clear the content if any
        if (this.nodata) {
          setTimeout(() => {
            document.getElementById('div_powgensettrendoveraday').innerHTML = 'No data available'
          }, 500)
          this.$forceUpdate()
        } else {
          setTimeout(() => {
            document.getElementById('div_powgensettrendoveraday').innerHTML = '<canvas id="chart_powgensettrendoveraday"></canvas>'
            var canvas = document.getElementById('chart_powgensettrendoveraday')
            var ctx = canvas.getContext('2d')
            ctx.canvas.height = gensetLbl.length * 17
            ctx.canvas.width = gensetLbl.length * 20
            this.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: gensetLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Genset (Units)'
                },
                legend: {
                  position: 'bottom'
                }
              }
            })
          }, 500)
          this.$forceUpdate()
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWaterConsTypeList () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterConsByCommId/', qry)
      .then(response => {
        this.storageNmListWithWaterCons = response.data
        if (response.data.length > 0) {
          this.selectedStorageNmWithWaterCons = this.storageNmListWithWaterCons[0].storage_id
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showWaterConsOverADay () {
      if (!this.selectedStorageNmWithWaterCons) {
        this.selectedStorageNmWithWaterCons = this.storageNmListWithWaterCons[0].storage_id
      }
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: handy.formatDBDate(this.fromDt) + ' ' + this.fromTime,
          to_dt: handy.formatDBDate(this.toDt) + ' ' + this.toTime,
          storage_id: this.selectedStorageNmWithWaterCons
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterConsTrendOverAdayByStorageId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var dtLbl = []
        var didx = []
        var widx = []
        var recAvgVal = {}
        var avgStorageLbl = []
        var modeLbl = ['In-flow (KL)', 'Out-flow (KL)']
        recAvgVal[0] = []
        recAvgVal[1] = []
        var cons = []
        var custStorageId = this.selectedStorageNmWithWaterCons
        // trend chart
        for (var r = 0; r < resObj.length; r++) {
          widx = avgStorageLbl.indexOf(resObj[r].storage_id)
          if (widx < 0) {
            widx = avgStorageLbl.length
            avgStorageLbl[widx] = resObj[r].storage_nm.substring(0, 10)
          }
          cons = resObj[r].cons[0]
          for (var i = 0; i < cons.length; i++) {
            didx = dtLbl.indexOf(handy.getTime12Hrs(cons[i].c_date))
            if (didx < 0 && cons[i].c_date) {
              didx = dtLbl.length
              dtLbl[didx] = handy.getTime12Hrs(cons[i].c_date)
            }
            // worry about trend of only user chosen water type
            if (custStorageId === resObj[r].storage_id) {
              if (!recAvgVal[0][didx] || !recAvgVal[1][didx]) {
                recAvgVal[0][didx] = 0
                recAvgVal[1][didx] = 0
              }
              recAvgVal[0][didx] += cons[i].water_receipt
              recAvgVal[1][didx] += cons[i].water_cons
            }
          }
        } // for every rec
        // chart 1
        // data set
        var dsets = []
        for (i = 0; i < modeLbl.length; i++) {
          dsets[i] = {
            label: modeLbl[i],
            backgroundColor: 'rgba(' + COLORS[(i === 0 ? i + 2 : i + 3)] + ',0.1)',
            borderColor: 'rgba(' + COLORS[(i === 0 ? i + 2 : i + 3)] + ',1)',
            data: recAvgVal[i],
            fill: true
          }
        }
        // clear the content if any
        setTimeout(() => {
          document.getElementById('div_watConsoveradaytrend').innerHTML = '<canvas id="chart_watConsoveradaytrend"></canvas>'
          var canvas = document.getElementById('chart_watConsoveradaytrend')
          canvas.height += avgStorageLbl.length * 30
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }, 500)
        this.consTrendOverADay = true
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadHygieneCat () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getSanCheckCatByCommId/', qry)
      .then(response => {
        this.hygCats = response.data
        this.loadHygiene()
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadHygiene () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) : this.fromDate,
          to_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) : this.fromDate
        }
      }
      this.hygList = []
      this.axios.get(config.SMARTILITY_API_URL + '/getSanCheckByCommIdAndcDate/', qry)
      .then(response => {
        this.hygList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadIncidentClass () {
      this.incidentTypes = {}
      this.axios.get(config.SMARTILITY_API_URL + '/getIncidentClass/')
      .then(response => {
        this.incidentTypes = handy.unique(response.data.map(rec => rec.incident_type)).sort()
        this.loadIncidents()
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadIncidents () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) + ' 00:00:00' : this.fromDate + ' 00:00:00',
          to_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) + ' 23:59:59' : this.fromDate + ' 23:59:59'
        }
      }
      this.incidentList = []
      this.axios.get(config.SMARTILITY_API_URL + '/getIncidentListDailyRep/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.incidentList = response.data
        } else {
          if (this.incidentTypes.length > 0) {
            this.incidentTypes.forEach(rec => {
              this.incidentList.push({
                incident_type: rec,
                incident_class: 'NIL'
              })
            })
          }
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadRemark () {
      var qry = {
        params: {
          from_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) : this.fromDate,
          to_dt: !this.aDay ? handy.formatDBDate(this.trendFrom) : this.fromDate,
          comm_id: this.lDashBoard.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getRemarksBasedOnCommId/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.lReport.remark_attendance = response.data[0].remark_attendance
          this.lReport.remark_water = response.data[0].remark_water
          this.lReport.remark_power = response.data[0].remark_power
        }
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadMoreRemark (curRemark) {
      var qry = {
        params: {
          from_dt: handy.formatDBDate(this.trendFrom),
          to_dt: handy.formatDBDate(this.trendTo),
          comm_id: this.lDashBoard.comm_id
        }
      }
      this.lReport.AttRemark = {}
      this.lReport.PowerRemark = {}
      this.lReport.WaterRemark = {}
      this.axios.get(config.SMARTILITY_API_URL + '/getRemarksBasedOnCommId/', qry)
      .then(response => {
        this.lReport.AttRemark = response.data.filter(rec => rec.remark_attendance !== null)
        this.lReport.PowerRemark = response.data.filter(rec => rec.remark_power !== null)
        this.lReport.WaterRemark = response.data.filter(rec => rec.remark_water !== null)
        this.showRemark = true
        if (curRemark === 'Att') {
          this.lReport.remark = 'Att'
        } else if (curRemark === 'Power') {
          this.lReport.remark = 'Power'
        } else {
          this.lReport.remark = 'Water'
        }
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadSanityChecksMore () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: handy.formatDBDate(this.trendFrom),
          to_dt: handy.formatDBDate(this.trendTo)
        }
      }
      this.sanList = []
      this.lSan = {}
      this.axios.get(config.SMARTILITY_API_URL + '/getSanCheckByCommIdAndcDate/', qry)
      .then(response => {
        this.sanList = response.data
        this.lSan = handy.unique(this.sanList.map(rec => handy.formatDate(rec.c_date)))
        this.showSanityChecks = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadIncidentMore () {
      var qry = {
        params: {
          comm_id: this.lDashBoard.comm_id,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      }
      this.lIncident = []
      this.lInc = {}
      this.axios.get(config.SMARTILITY_API_URL + '/getIncidentListDailyRep/', qry)
      .then(response => {
        this.lIncident = response.data
        this.lInc = handy.unique(this.lIncident.map(rec => handy.formatDate(rec.created_on)))
        this.showIncident = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    }
  }
}
</script>
